<template>
  <div class="record-view right_auth">
    <div class="time">
      <label>订单时间： </label>
      <sd-select :options="options" :open="open"
                 @changeOpen="open =! open" :value="dateRange" @changeOption="changeRange"></sd-select>
    </div>
    <div class="invoice-btn">
      <button class="btn_g primary" v-show="list.length" @click="batchInvoice()">开具发票</button>
      <span class="invoice_tag">注： ①仅在线支付的订单可开具发票； ②单次开票订单总额不小于300元。</span>
    </div>
    <div v-if="list.length">
      <table>
        <colgroup>
          <col class="col_100">
          <col class="col_270">
          <col class="col_100">
          <col class="col_100">
          <col class="col_230">
          <col class="col_370">
        </colgroup>
        <thead>
        <tr>
          <td><input :disabled="!onlineList.length" type="checkbox" v-model="isSelectedAll" @click="selectAll">全选</td>
          <td>支付时间</td>
          <td>实付金额</td>
          <td>优惠金额</td>
          <td>支付方式</td>
          <td>订单号</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="li in list">
          <td><input :disabled="li.onlinePay != 2" type="checkbox" :value="li" v-model="selected"></td>
          <td>{{li.payTime | time('YYYY-MM-DD HH:mm')}}</td>
          <td class="red">￥{{li.realityPay}}</td>
          <td>{{li.couponAmount || ''}}</td>
          <td>{{li.onlinePay | way}}</td>
          <td>
            <span v-html="orderLineFeed(li.orderNumbers)"></span>
            <div class="invoiced" v-if="li.invoiceId"></div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="page_wrap">
        <sd-pager ref="pager" :page-data="page" @page-change="pageChange"></sd-pager>
      </div>
    </div>
    <div class="g_empty" v-if="!list.length">
      <p class="info">没有相关支付记录~</p>
    </div>
  </div>
</template>
<script>
  import sdSelect from '../components/sdSelect'
  import {util} from '../service/util'
  import { mapState, mapActions , mapGetters } from 'vuex'
  import moment from 'moment'
  import sdPager from '../components/sdPager.vue'
  let API = util.api(['SEARCHPAYRECORD']);
  export default{
    components:{sdSelect,sdPager},
    data(){
      return {
        // 已经勾选的订单
        selected: [],
        isSelectedAll: false,
        options:[
          {
            label:'全部',
            param:{

            }
          },
          {
            label:'近三个月订单',
            param:{
              beginTime : moment().subtract(3,'month').format('YYYY-MM-DD'),
              endTime : moment().format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label:'近六个月订单',
            param:{
              beginTime : moment().subtract(6,'month').format('YYYY-MM-DD'),
              endTime : moment().format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label:'一年前订单',
            param:{
              endTime : moment().subtract(1,'year').format('YYYY-MM-DD')
            }
          },
        ],
        open:false,
        dateRange: {label: '全部',param:{}},
        list:[],
        page:{
          pageNo:1,
          pageSize:25,
          totalPage:1
        }
      }
    },
    computed:{
      searchPay(){
        return{
          ...this.dateRange.param,
        }
      },
      paramPage(){
        return{
          ...this.page
        }
      },
      /**
       * 允许在线开票的发票对象
       * - 在线提交的发票 onlinePay == 2
       */
      onlineList() {
        return this.list.filter(d => d.onlinePay == 2);
      }
    },
    methods:{
      /**
       * 选择全部
       */
      selectAll() {
        if(!this.isSelectedAll){
          this.selected = [];
          this.onlineList.forEach( d => {
            this.selected.push(d);
          })
//          this.list.forEach( d => {
//            this.selected.push(d);
//          })
        } else {
          this.selected = [];
        }
      },
      /**
       * 批量开票
       * 1.已经支付，2.未开票，3.总金额大于300
       */
      batchInvoice() {
        let pays = [],
          money = 0;
        for(let i in this.selected){
          let d = this.selected[i];
          if(d.invoiceId){
            util.confirm.error('请选择未申请开票的支付记录!');
            return;
          }
          // 60天之前的订单，不能开票
          if(moment(d.payTime).isBefore(moment().add(-60,'d'))){
            util.confirm.error('60天之前的订单，无法开票！');
            return;
          }
          // 10月1日之前的订单，不能开票
          // if(moment(d.payTime).isBefore(moment('2017-10-1'))){
          //     util.confirm.error('无可开票记录！');
          //     return;
          // }
          money += d.realityPay;
          pays.push(d);
        }
        if(!pays.length){
          util.confirm.error('请选择支付记录！');
          return;
        }
        // 校验
        if(money < 300){
          util.confirm.error('开票总价需大于300元！');
          return;
        }
        this.$store.commit('INVOICEPAYS', pays);
        this.$router.push({
          name: 'InvoiceView'
        })
      },
      /**
       * 取消全部选中
       */
      unSelectAll() {
        this.selected = [];
      },
      // 订单换行
      orderLineFeed(orderNums) {
        if(orderNums.substr(0,1) == ','){
          orderNums = orderNums.substr(1);
        }
        return orderNums.replace(/\,/g,'<br/>');
      },
      changeRange(data){
        this.dateRange = data;
        this.open = !this.open;
        //初始页码
        this.page = this.$options.data().page;
        this.search();
      },
      pageChange(){
        this.search();
      },
      search(){
        let _this = this;
        util.kAjax(API.SEARCHPAYRECORD,{searchPay:_this.searchPay,page:_this.paramPage},json=>{
          _this.list = json.data.datas;
          this.page.pageNo = json.data.pageNo;
          this.page.totalPage = json.data.totalPage;
          this.unSelectAll();
        });
      }
    },
    watch: {
      selected(value) {
        if(!this.selected.length){
          this.isSelectedAll = false;
          return;
        }
        this.isSelectedAll = (value.length && value.length == this.onlineList.length);
        // this.isSelectedAll = (value.length == this.list.length);
      }
    },
    mounted(){
      this.search();
    }
  }
</script>

<style scoped="" lang="scss">
  .invoice_tag{
    color: red;
    float: right;
    font-size: 14px;
    /*display: inline-block;*/
    /*vertical-align: sub;*/
    /*vertical-align: -webkit-baseline-middle;*/
  }
</style>



// WEBPACK FOOTER //
// PayRecord.vue?5549f3d2